export default "__VITE_ASSET__CiO7xq1g__"